import { getConfigForMeasuredTest, getConfigForTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/ParticleDensityWorksheet/derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from 'Components/Worksheets/ParticleDensityWorksheet/measuredUsingConfig';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Equipment.MeasurementBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      ...getConfigForTest(qestIds.moistureContent.BS_1377_2.rev1990, 'data.TestPortions.MoistureDetermination'),

      ...getConfigForMeasuredTest(
        qestIds.oversizeDetermination.BS_1377_2_Clause_9_2,
        'data.Preparation.AssociatedOversizeDetermination'
      ),

      [`${prefix}.Measurements.MinimumRoomTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.MaximumRoomTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.RoomTemperatureRange`]: { format: { nearest: 1 } },

      [`${prefix}.Measurements.TestMeasurements.SoakingPeriod`]: { uom: 'h', format: { nearest: 0.1 } },
      [`${prefix}.Measurements.TestMeasurements.ShakingPeriod`]: { uom: 'min', format: { nearest: 1 } },
      [`${prefix}.Measurements.TestMeasurements.WaterTemperature1`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.TestMeasurements.WaterTemperature2`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.TestMeasurements.ParticleDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Results.AvgParticleDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Results.MaterialRetainedOn37_5mmSieve`]: { format: { nearest: 1 } },
      [`${prefix}.Results.MaterialRetainedOn50_0mmSieve`]: { format: { nearest: 1 } },
      [`${prefix}.ImagesAndRemarks.Remarks`]: { maxLength: 255 },
      [`${prefix}.ImagesAndRemarks.InternalRemarks`]: { maxLength: 255 },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getLabelConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Equipment.DryMassBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

export { getConfig };

export default {
  [qestIds.particleDensity.BS_1377_2_Clause_9_2.rev2022]: getConfig,
};
